import { QueryFactory } from "../../../../Common";
import { RC } from "../../../../Contracts";
export const QGetWageringInformation = QueryFactory(RC.QueryTypes.GetWageringInformation);
//# sourceMappingURL=QGetWageringInformation.js.map